import {
  PusherProvider,
  useDashboardReactiveMap,
} from '@hopin-team/dashboard-shared-react';
import Pusher from 'pusher-js';
import React, { useEffect, useState } from 'react';

type PusherProviderWrapperProps = {
  children: React.ReactNode;
};

export const PusherProviderWrapper = ({
  children,
}: PusherProviderWrapperProps) => {
  const reactiveMap = useDashboardReactiveMap();
  const [client, setClient] = useState<Pusher | undefined>(undefined);

  useEffect(() => {
    (async () => {
      const pusherClient = await reactiveMap.getMapContext('pusher_client');

      if (!pusherClient) {
        return;
      }

      setClient(pusherClient as unknown as Pusher);
    })();
  }, [reactiveMap]);

  return <PusherProvider client={client as any}>{children}</PusherProvider>;
};
